import React, { useState, useEffect, useMemo } from "react";
import { styled } from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import Grid from '@mui/material/Grid';
import { AgrgegarAreasButton } from "./AgregarAreasButton";
import { useAreas } from "./State/AreasContext";
import { AgregarAreas } from "./AgregarAreas";
import { VerAreas } from "./VerAreas";
import { ModalGeneral } from "../Componentes/ModalGeneral";
import { BorrarAreaModal } from "./Componentes/BorrarAreaModal";
import { EditarAreas } from "./EditarAreas"
import Box from "@mui/material/Box";
import { useAuth } from "../Auth/State/AuthContext";
import { VerAgenda } from './VerAgenda';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from "@mui/material/CircularProgress";

const Posiciontabla = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        position: 'relative',
    }
}));

export const ListaAreas = () => {
    const { hasRole } = useAuth();
    const { setValue, getAreasTree } = useAreas();
    const matches = useMediaQuery('(min-width:1185px)');
    const [openModalAgregar, setOpenModalAgregar] = useState(false);
    const [openModalVer, setOpenModalVer] = useState(false);
    const [openModalVerAgenda, setOpenModalVerAgenda] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalEliminar, setOpenModalEliminar] = useState(false);
    const [areaAgregar, setAreaAgregar] = useState({});
    const [areaVer, setAreaVer] = useState({});
    const [areaEliminar, setAreaEliminar] = useState({});
    const [areaEditar, setAreaEditar] = useState({});
    const [loading, setLoading] = useState(false);
    const [areaData, setAreaData] = useState([]);
    const [handleUpdates, setHandleUpdates] = useState(false);

    async function fetchAreas() {
        setLoading(true)
        const areasTree = await getAreasTree()
        const restructuredData = processAreasTree(areasTree);
        setAreaData(restructuredData)
        setLoading(false)
    }

    useEffect(() => {
        fetchAreas()
    }, [handleUpdates]);

    const handleUpdate = () => {
        setHandleUpdates(!handleUpdates)
    }

    const inter = (response) => {
        return response.map((i) => {
            const numeroInicio = i.indexOf(":") + 1;
            const numeroFin = i.indexOf(";");
            const numero = parseInt(i.substring(numeroInicio, numeroFin));

            const especificacionInicio = i.lastIndexOf(":") + 1;
            const especificacion = i.substring(especificacionInicio);

            return {
                numero: numero,
                especificacion: especificacion
            }
        })
    }

    const processAreasTree = (areas) => {
        return areas.map(area => {
            const restructuredArea = {
                id: area.id,
                path: area.path,
                nombre: area.name,
                subareas: area.subGroups.length !== 0 ? area.subGroups.map(subGroup => subGroup.name) : [],
                observaciones: area.attributes?.observaciones?.length > 0 ? area.attributes.observaciones[0] : '',
                internos: area.attributes?.internos?.length > 0 ? inter(area.attributes.internos) : [],
                oficinas: area.attributes?.oficinas?.length > 0 ? area.attributes.oficinas : [],
                subRows: area.subGroups?.length > 0 ? processAreasTree(area.subGroups) : []
            };

            return restructuredArea;
        });
    };

    const actions = useMemo(() => {
        const actionsList = [];
        if (hasRole(['ROLE_AREAS'])) {
            actionsList.push({
                icon: <VisibilityIcon sx={{ color: "#B71234" }} />,
                tooltip: 'Ver información del área',
                onClick: (row) => abrirModalVer(row.original)
            });
        }
        if (hasRole(["ROLE_CREAR_AREAS"])) {
            actionsList.push({
                icon: <AddIcon sx={{ color: "#B71234" }} />,
                tooltip: 'Agregar subárea',
                onClick: (row) => abrirModalAgregar(row.original)
            });
        }
        if (hasRole(["ROLE_MODIFICAR_AREAS"])) {
            actionsList.push({
                icon: <EditIcon sx={{ color: "#B71234" }} />,
                tooltip: 'Editar área',
                onClick: (row) => abrirModalModificar(row.original)
            });
        }
        if (hasRole(["ROLE_BORRAR_AREAS"])) {
            actionsList.push({
                icon: <DeleteIcon sx={{ color: "#B71234" }} />,
                tooltip: 'Eliminar área',
                onClick: (row) => abrirModalEliminar(row.original)
            });
        }
        return actionsList;
    }, [hasRole]);

    const abrirModalModificar = (rowData) => {
        setAreaEditar(rowData);
        setOpenModalEditar(true);
    };

    const abrirModalEliminar = (rowData) => {
        setAreaEliminar(rowData);
        setOpenModalEliminar(true);
    };

    const abrirModalVer = (rowData) => {
        setAreaVer(rowData);
        setOpenModalVer(true);
    };

    const abrirModalVerAgenda = (rowData) => {
        setAreaVer(rowData);
        setOpenModalVerAgenda(true);
    };

    const abrirModalAgregar = (rowData) => {
        setValue({
            path: rowData.path,
            nombre: '',
            integrantes: [],
            observaciones: '',
            oficinas: [],
            internos: [],
        });
        setAreaAgregar(rowData);
        setOpenModalAgregar(true);
    };

    const onClose = () => {
        setOpenModalAgregar(false);
        setOpenModalVer(false);
        setOpenModalVerAgenda(false);
        setOpenModalEditar(false);
        setOpenModalEliminar(false);
    };

    const columns = [
        {
            header: 'Áreas',
            accessorKey: 'nombre',
            size: 130,
            cell: ({ cell }) => (
                <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: 200 }}>
                    {cell.getValue()}
                </div>
            ),
        },
        {
            header: '­',
            accessorKey: 'actions',
            size: 130,
            enableSorting: false,
            enableFiltering: false,
            enableColumnFilter: false,
            enableColumnActions: false,
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {actions.map((action, index) => (
                        <IconButton key={index} onClick={() => action.onClick(row)} title={action.tooltip}>
                            {action.icon}
                        </IconButton>
                    ))}
                </div>
            ),
        }
    ];

    return (
        <Box sx={{ px: matches ? 2 : 0 }}>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <Typography fontSize={matches ? "30px" : "28px"} my="40px" mx="10px">
                        Gestión de Áreas
                    </Typography>
                </Grid>
                {/* <Grid item xs={4}>
                    {hasRole(["ROLE_CREAR_AREAS"]) && (
                        <AgrgegarAreasButton setAreaAgregar={setAreaAgregar} setOpen={setOpenModalAgregar} />
                    )}
                </Grid> */}
            </Grid>

            <Posiciontabla>
                {loading ?
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "80px" }}>
                        <CircularProgress />
                    </div>
                    :
                    <MaterialReactTable
                        columns={columns}
                        data={areaData}
                        enableExpanding={true}
                        enableExpandAll={true}
                        enableFullScreenToggle={false}
                        localization={MRT_Localization_ES}
                        paginateExpandedRows={false}
                        enableColumnResizing={matches ? false : true}
                        layoutMode={matches ? 'flex' : 'grid'}
                        displayColumnDefOptions={{
                            'mrt-row-expand': {
                                size: 80,
                            },
                        }}
                    />}
            </Posiciontabla>

            <ModalGeneral
                Contenido={<AgregarAreas handleUpdate={handleUpdate} onClose={onClose} areaPadre={areaAgregar} />}
                open={openModalAgregar}
                handleOpen={() => setOpenModalAgregar(true)}
                onClose={onClose}
            />
            <ModalGeneral
                Contenido={<VerAreas area={areaVer} />}
                open={openModalVer}
                handleOpen={() => setOpenModalVer(true)}
                onClose={onClose}
            />
            <ModalGeneral
                Contenido={<VerAgenda onClose={onClose} area={areaVer} setOpenModalEditar={setOpenModalEditar} setAreaEditar={setAreaEditar} setOpenModalEliminar={setOpenModalEliminar} setAreaEliminar={setAreaEliminar} />}
                open={openModalVerAgenda}
                handleOpen={() => setOpenModalVerAgenda(true)}
                onClose={onClose}
            />
            <ModalGeneral
                Contenido={<EditarAreas handleUpdate={handleUpdate} onClose={onClose} grupo={areaEditar} areas={areaData} />}
                open={openModalEditar}
                handleOpen={() => setOpenModalEditar(true)}
                onClose={onClose}
            />
            <BorrarAreaModal
                area={areaEliminar}
                open={openModalEliminar}
                onClose={() => setOpenModalEliminar(false)}
                handleUpdate={handleUpdate}
            />
        </Box>
    );
};
